import React from "react";
import "./Feedback.css";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

const Feedback = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [visibleCount, setVisibleCount] = useState(4);

  const reviews = [
    {
      name: "Amit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Honey",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Harvinder",
      rating: 5,
      comment: "Excellant",
    },

    {
      name: "Sumit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Smith",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Adarsh",
      rating: 1,
      comment: "Very poor service",
    },

    {
      name: "Amit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Honey",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Harvinder",
      rating: 5,
      comment: "Excellant",
    },

    {
      name: "Sumit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Smith",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Adarsh",
      rating: 1,
      comment: "Very poor service",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const bottomReached =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;

      if (bottomReached && visibleCount < reviews.length) {
        setVisibleCount((prev) => prev + 2);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleCount, reviews.length]);

  // Validation function
  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(email)) newErrors.email = "Invalid email format.";
    if (!phone.trim()) newErrors.phone = "Phone number is required.";
    else if (!/^\d{10}$/.test(phone)) newErrors.phone = "Phone must be 10 digits.";
    if (!rating) newErrors.rating = "Rating is required.";
    if (!comment.trim()) newErrors.comment = "Comment is required.";
    return newErrors;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
    setSubmitting(true);
    try {
      // Replace with your API endpoint
      const response = await fetch("https://api.kiorhealthcare.com/v1/user/websiteFeedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name, email: email, mobileNumber: phone, rating: rating, comment:comment })
      });
      if (response.ok) {
        setSuccess("Feedback submitted successfully!");
        setName(""); setEmail(""); setPhone(""); setRating(0); setComment("");
        setErrors({});
      } else {
        setSuccess("Failed to submit feedback. Try again later.");
      }
    } catch (error) {
      setSuccess("Network error. Try again later.");
    }
    setSubmitting(false);
  };

  return (
    <>
      <div className="feedback">
        <div className="coustom_container">
          <h2>Customer's Review & Feedback Form</h2>
          <Row>
            <Col md={12}>
              <Card className="mb-4 p-4 rounded shadow bg-light">
                <Form onSubmit={handleSubmit} noValidate>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Your name"
                          value={name}
                          onChange={e => setName(e.target.value)}
                          isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Your email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Your phone number"
                          value={phone}
                          onChange={e => setPhone(e.target.value)}
                          isInvalid={!!errors.phone}
                        />
                        <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Ratings</Form.Label>
                        <div className="d-flex gap-2">
                          {[...Array(5)].map((star, index) => {
                            const currentRating = index + 1;
                            return (
                              <button
                                key={index}
                                type="button"
                                className="btn p-0 border-0 bg-transparent"
                                onClick={() => setRating(currentRating)}
                                onMouseEnter={() => setHover(currentRating)}
                                onMouseLeave={() => setHover(0)}
                              >
                                <FaStar
                                  size={28}
                                  color={
                                    currentRating <= (hover || rating)
                                      ? "#ffc107"
                                      : "#e4e5e9"
                                  }
                                  style={{ transition: "color 200ms" }}
                                />
                              </button>
                            );
                          })}
                        </div>
                        {errors.rating && <div className="text-danger mt-1">{errors.rating}</div>}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3 fs-5 fw-bolder text-dark">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="message......"
                      rows={5}
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                      isInvalid={!!errors.comment}
                    />
                    <Form.Control.Feedback type="invalid">{errors.comment}</Form.Control.Feedback>
                  </Form.Group>
                  <Button className="btn_submit" type="submit" disabled={submitting}>
                    {submitting ? "Submitting..." : "Submit"}
                  </Button>
                  {success && <div className={`mt-3 ${success.includes("success") ? "text-success" : "text-danger"}`}>{success}</div>}
                </Form>
              </Card>
            </Col>
            {/* ...existing code... */}
          </Row>
        </div>
      </div>
    </>
  );
};

export default Feedback;
